module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mobile-redirection/mobile-redirection.component.scss
// module id = ./src/app/mobile-redirection/mobile-redirection.component.scss
// module chunks = main